import React from 'react';
import {useIntl} from 'react-intl';
import {Modal, Text} from '@forecast-it/design-system';

type Props = {
	templateName: string;
	/** The project already has a phase or deliverable, so confirming replaces them. */
	hasContent: boolean;
	/** A replace also removes the deliverables, so the prompt names them. */
	projectUsesDeliverables: boolean;
	submitting: boolean;
	onConfirm: () => void;
	onCancel: () => void;
};

export const InsertTemplateConfirm = ({
	templateName,
	hasContent,
	projectUsesDeliverables,
	submitting,
	onConfirm,
	onCancel,
}: Props): JSX.Element => {
	const intl = useIntl();
	const kind = hasContent ? 'replace' : 'insert';
	const bodyId =
		hasContent && projectUsesDeliverables
			? 'baseline_templates.insert.confirm.replace_body_deliverables'
			: `baseline_templates.insert.confirm.${kind}_body`;
	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={onCancel} closeOnInteractOutside={false}>
			<Modal.Title>{intl.formatMessage({id: `baseline_templates.insert.confirm.${kind}_title`})}</Modal.Title>
			<Modal.Content>
				<Text>{intl.formatMessage({id: bodyId}, {name: templateName})}</Text>
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onConfirm} disabled={submitting} dataCy="insert-baseline-template-confirm">
					{intl.formatMessage({id: `baseline_templates.insert.confirm.${kind}`})}
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton
					onPress={onCancel}
					disabled={submitting}
					dataCy="insert-baseline-template-confirm-cancel"
				>
					{intl.formatMessage({id: 'common.cancel'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};
